export default {"src":"/_next/static/media/B42_Logo_onyx.4f8c5373.svg","height":234,"width":376,"blurWidth":0,"blurHeight":0};